import { Stack } from 'design-system'
import { FC } from 'react'

import { ExpandableSection } from 'src/components/board/archived/expandable-section'

export const ContractExpiredAdminView: FC = () => (
  <div className="py-4 text-left text-slate-500">
    Your Yellowdig contract ended more than 30 days ago, so your communities are
    no longer accessible. Once a new contract is in place, we can restore
    everything, subject to the terms of our agreements. We’re ready to help you
    get there quickly.
    <Stack gap={3}>
      <ExpandableSection message="What happens to my community’s content and data?">
        We retain your data subject to the terms of our agreements. All
        community content, discussions, and member data remain intact for a
        retention period and can be restored once a new contract is agreed upon.
      </ExpandableSection>
      <ExpandableSection message="Who should I contact?">
        Reach out to your Yellowdig account contact to set up a new contract, or
        email <a href="mailto:support@yellowdig.com">support@yellowdig.com</a>{' '}
        and we’ll connect you with the right person.
      </ExpandableSection>
    </Stack>
  </div>
)
